import { createSlice, createAction } from '@reduxjs/toolkit';

// Saga-triggered actions
export const createFilledUnfilledReportAction = createAction(
    'filledUnfilledReports/createReport',
);
export const fetchFilledUnfilledReportsAction = createAction(
    'filledUnfilledReports/fetchReports',
);
export const pollFilledUnfilledReportStatusAction = createAction(
    'filledUnfilledReports/pollReportStatus',
);
export const stopFilledUnfilledPollingAction = createAction(
    'filledUnfilledReports/stopPolling',
);
export const checkExistingFilledUnfilledReportAction = createAction(
    'filledUnfilledReports/checkExisting',
);
export const deleteFilledUnfilledReportAction = createAction(
    'filledUnfilledReports/deleteReport',
);

const initialState = {
    reports: [],
    total: 0,
    loading: false,
    creating: false,
    activeReport: null,
    existingReport: null,
    checkingExisting: false,
    error: null,
};

const filledUnfilledReportsSlice = createSlice({
    name: 'filledUnfilledReports',
    initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload;
        },
        setCreating(state, action) {
            state.creating = action.payload;
        },
        reportsFetched(state, action) {
            state.reports = action.payload.reports;
            state.total = action.payload.total;
            state.loading = false;
        },
        reportCreated(state, action) {
            state.creating = false;
            state.activeReport = action.payload;
            state.reports = [action.payload, ...state.reports];
            state.total += 1;
        },
        reportStatusUpdated(state, action) {
            const report = action.payload;
            state.activeReport = report;
            const idx = state.reports.findIndex(r => r._id === report._id);
            if (idx !== -1) {
                state.reports[idx] = report;
            }
        },
        clearActiveReport(state) {
            state.activeReport = null;
        },
        setExistingReport(state, action) {
            state.existingReport = action.payload;
            state.checkingExisting = false;
        },
        setCheckingExisting(state, action) {
            state.checkingExisting = action.payload;
        },
        reportDeleted(state, action) {
            state.reports = state.reports.filter(r => r._id !== action.payload);
            state.total = Math.max(0, state.total - 1);
        },
        setError(state, action) {
            state.error = action.payload;
            state.loading = false;
            state.creating = false;
        },
    },
});

export const {
    setLoading,
    setCreating,
    reportsFetched,
    reportCreated,
    reportStatusUpdated,
    clearActiveReport,
    reportDeleted,
    setExistingReport,
    setCheckingExisting,
    setError,
} = filledUnfilledReportsSlice.actions;

// Selectors
export const getFilledUnfilledReports = state =>
    state.filledUnfilledReports.reports;
export const getFilledUnfilledReportsTotal = state =>
    state.filledUnfilledReports.total;
export const getFilledUnfilledReportsLoading = state =>
    state.filledUnfilledReports.loading;
export const getFilledUnfilledReportsCreating = state =>
    state.filledUnfilledReports.creating;
export const getActiveFilledUnfilledReport = state =>
    state.filledUnfilledReports.activeReport;
export const getExistingFilledUnfilledReport = state =>
    state.filledUnfilledReports.existingReport;
export const getCheckingExistingFilledUnfilled = state =>
    state.filledUnfilledReports.checkingExisting;

export default filledUnfilledReportsSlice.reducer;
